module.exports = __webpack_public_path__ + "img/icon_qingpai_des_2.03147993.jpg";